<div class="fm-tracking-header">
  @if (backLink) {
    <a [routerLink]="backLink" class="fm-tracking-back" aria-label="Go back">
      <i class="bi bi-arrow-left"></i>
    </a>
  } @else {
    <button
      type="button"
      class="fm-tracking-back"
      [disabled]="!isBrowser"
      (click)="goBack()"
      aria-label="Go back"
    >
      <i class="bi bi-arrow-left"></i>
    </button>
  }

  <div class="fm-tracking-header-text">
    @if (title) {
      <h2 class="fm-tracking-title mb-0">{{ title }}</h2>
    }
    @if (promptText || categoryName) {
      <p class="fm-tracking-subtitle mb-0">
        @if (promptText) {
          <span class="fm-tracking-quote">&ldquo;{{ promptText }}&rdquo;</span>
        }
        @if (promptText && categoryName) {
          <span class="fm-tracking-sep">-</span>
        }
        @if (categoryName) {
          <span>{{ categoryName }}</span>
        }
      </p>
    }
  </div>
</div>
